import { Error as Icon } from '@mos-cat/ds-icons';
import { Theme } from '@mos-cat/ds-theme';
import { createComponent, createHook } from 'reakit-system';
import { BoxHTMLProps, BoxOptions, useBox } from '../Box/Box';
import { TextHTMLProps, TextOptions, TextProps, useText } from '../Text/Text';
import { WHCM } from '../constants';

/**
 * @beta
 */
export type ErrorProps = Omit<
  TextProps,
  'lineHeight' | 'fontSize' | 'color' | 'fontWeight'
>;

let useErrorIcon = createHook<BoxOptions & { theme: Theme }, BoxHTMLProps>({
  compose: [useBox],
  useOptions(options) {
    return {
      ...options,
      display: 'inline',
      verticalAlign: 'middle',
      mr: 'errorIconMarginRight',
      mt: 'errorIconMarginTop',
      size: '1em',

      styles: {
        '& path': {
          fill: 'currentColor',
        },
        [WHCM]: {
          fill: 'Highlight',
        },
      },
    };
  },
});

let ErrorIcon = createComponent({
  useHook: useErrorIcon,
  as: Icon,
});

let useError = createHook<
  Omit<TextOptions, 'color' | 'fontSize' | 'lineHeight'>,
  TextHTMLProps
>({
  compose: [useText],
  useOptions(options) {
    return {
      ...options,
      color: 'errorColor',
      fontSize: 'errorFontSize',
      lineHeight: 'errorLineHeight',
      styles: {
        display: 'block',

        [WHCM]: {
          color: 'Highlight',
        },
      },
    };
  },
  useProps(options, props) {
    return {
      ...props,
      children: (
        <>
          <ErrorIcon />
          {props.children}
        </>
      ),
    };
  },
});

/**
 * @beta
 */
export const Error = createComponent({
  as: 'span',
  useHook: useError,
});
